// Animated "BB" mark for the sign-in splash. Keyframes live in AuthProvider.
const bar = { animation: "bb-bar-slide 1.2s ease-out both" };

export const SplashMark = () => (
    <svg viewBox="0 0 50 50" style={{ width: "100%", height: "100%" }}>
        <g style={{}}>
            <polygon fill="currentColor" points="10.468,24.443 13.404,27.161 29.834,27.161 29.834,24.443" style={{ ...bar, animationDelay: "0s" }} />
            <polygon fill="currentColor" points="18.701,31.31 21.64,34.028 29.834,34.028 29.834,31.31" style={{ ...bar, animationDelay: "0.15s" }} />
            <polygon fill="currentColor" points="1.726,17.561 4.665,20.28 29.834,20.28 29.834,17.561" style={{ ...bar, animationDelay: "0.3s" }} />
            <path
                fill="currentColor"
                d="M48.193,30.869c0-2.466-1.687-4.703-3.923-5.205l-0.623-0.14 l0.595-0.231c2.223-0.862,3.447-2.576,3.447-4.826c0-2.751-2.159-5.527-6.981-5.527h-8.244v21.71H41.12 C45.35,36.65,48.193,34.326,48.193,30.869z M35.799,17.61h4.592c2.479,0,3.901,1.202,3.901,3.298 c0,2.106-1.385,3.266-3.901,3.266H35.799V17.61z M35.799,33.978V26.846h4.877c2.542,0,4.184,1.43,4.184,3.642 c0,2.218-1.478,3.49-4.056,3.49H35.799z"
                style={{ ...bar, animationDelay: "0.45s" }}
            />
        </g>
    </svg>
);
